export default __webpack_public_path__ + "static/media/Vestment of the Grand Monarch.16c436ba.jpg";